// utils/hints.js
import DistanceCalculation from "../assets/images/distance-calculate-formula.png";
const hints = {
  Mission1: {
    Rookie: [
      "Pay attention to the part numbers printed on the ICs. The datasheets will help you decode their functions.",
    ],
    Intermediate: [
      "Use the multimeter to trace connections. The datasheet for the microcontroller includes the pinout diagram and memory address.",
    ],
    Advanced: [
      "FSK modulation looks like 'bat ears' on the spectrum display. Use the datasheet to set appropriate frequency ranges.",
    ],
  },
  Mission2: {
    Rookie: [
      "The password is a mix of numbers, letters (upper or lower case), and one symbol. Use the feedback to refine your guesses. It may or may not include 'Fox' or any variation of these letters.",
    ],
    Intermediate: [
      `Test a variety of passwords and see what error messages are returned. Then determine what changes you can make, and what criteria need to be met, to stop the error messages. A password that is correct will not produce any error messages.`,
    ],
    Advanced: [
      "Input passwords into the timing script. Observe and log response times.",
      "Use the timing discrepancies to adjust your inputs: Faster response: Incorrect character.",
    ],
  },
  Mission3: {
    Rookie: [
      "Look for the earliest recorded timestamp to locate the launch site.",
    ],
    Intermediate: [
      "You can calculate the bearing of the drone between 2 points using the following format:",
      // "Use Pythagoras' theorem and trigonometry.",
      `Calculating Waypoints
      Traveling d metres from (x₁,y₁) on a heading h degrees to (x₂,y₂)
      x₂ = x₁ + (dx sin h)
      y₂ = y₁ + (dx cos h)`,
    ],
    Advanced: [
      "You can calculate the bearing of the drone between 2 points using the following format:",
      "Use Pythagoras' theorem and trigonometry.",
      "In this mission, a heading of 0° points East (to the right on the map).",
    ],
  },
  Mission4: {
    Rookie: [
      "Pay attention to the loop and how the key value changes with each iteration:",
    ],
    Intermediate: [
      "Try replacing the variable names with more meaningful names.",
    ],
    Advanced: [
      "Use Notepad feature to re-write the challenge code in a high-level language",
    ],
  },
};

// Function to get image URL for specific mission hints
const getHintImage = (mission, level) => {
  if (mission === 3 && (level === "Intermediate" || level === "Advanced")) {
    return DistanceCalculation;
  }
  return null;
};

export const getHint = (mission, level) => {
  const missionKey = `Mission${mission}`;
  if (!hints[missionKey]) {
    return { text: "Hint not found: Invalid mission number.", image: null };
  }
  if (!hints[missionKey][level]) {
    return {
      text: `Hint not found: Level "${level}" does not exist for Mission ${mission}.`,
      image: null,
    };
  }

  return {
    text: hints[missionKey][level],
    image: getHintImage(mission, level),
  };
};
